import React, { useContext } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import { hasConflicts } from "./utils";

// The doubled && raises the specificity over "body.generic .btn-default", which
// sets the button background as important. The color is the red of the warnings
// in the QoE metrics table, the same one on every theme.
const Button = styled.button`
  &&.has-conflicts,
  &&.has-conflicts:hover,
  &&.has-conflicts:focus,
  &&.has-conflicts:active {
    background-color: #cc0000 !important;
    color: #ffffff !important;

    i.material-icons {
      color: inherit;
    }
  }
`;

const CLASSES = "btn btn-default waves-effect shadow-none";

// Show rule conflicts button, highlighted when the view has rule conflicts.
const ConflictsButton = ({ conflicts, view, id }) => {
  const actions = useContext(ActionsContext);
  const hasRuleConflicts = hasConflicts(conflicts);

  return (
    <Button
      type="button"
      className={hasRuleConflicts ? `${CLASSES} has-conflicts` : CLASSES}
      id={id}
      title={hasRuleConflicts ? "There are rule conflicts" : undefined}
      onClick={() => actions.send("open-conflict-modal", view)}
    >
      <i className="material-icons">playlist_add_check</i>
      <span>Show Rule Conflicts...</span>
    </Button>
  );
};

export default ConflictsButton;
